/**
 * Features that are built but deliberately not offered yet.
 *
 * A flag here hides a feature from the UI without removing it: the pages, the API client and the
 * server endpoints all stay exactly as they are, so turning it back on is a one-line change rather
 * than a revert. Hiding rather than deleting matters for anything already sold — a company that
 * has the add-on on its Stripe subscription keeps paying whether or not the button is drawn, so
 * check the billing side too before flipping one of these off for good.
 */

/**
 * Invoice-scan OCR: upload a supplier invoice and have the products proposed in bulk
 * (`pages/products/InvoiceScanModal`, the +€3/mo add-on card on Pagesa & Abonimi).
 *
 * Off for now. Hidden in two places, and both must stay in step: the "Importo nga Faturë" button
 * on Produktet, and the add-on card that sells it — offering the purchase while the feature it
 * unlocks is invisible would be worse than either.
 */
export const INVOICE_SCAN_ENABLED = false;

/**
 * Fiscalization (SEF/ATK): the coupon pages, the POS units, the desktop till and the +€10/mo add-on
 * that sells them.
 *
 * Off in the cloud app while ATK certification is still open — the module is not offered, sold or
 * advertised until then. Nothing is removed: the pages, `api/client` and every endpoint stay as
 * they are, and a company that already has the add-on keeps paying for it, so check the billing
 * side before turning it off for good.
 *
 * It gates the cloud back office only. **An installed till ignores it** (`usePos().isPos`): a till
 * exists to issue coupons, and hiding fiscalization there would leave the machine at the counter
 * with nothing to do — its licence, its sync and its own settings stay exactly as they are.
 *
 * Hidden in six places, and they must stay in step, otherwise the app sells or promises something
 * it does not show: the sidebar entry and the `/fiscalization` route (App.js), the add-on card on
 * Pagesa & Abonimi, the "Fiskalizo" action on Faturat, the till installations card on Cilësimet,
 * and the fiscalization/till copy on the public landing page.
 */
export const FISCALIZATION_ENABLED = false;
